import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { loading, enumData } from '@/decorators';

var OnwayDetail = function (_super) {
  __extends(OnwayDetail, _super);

  function OnwayDetail() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.columns = [];
    _this.loadingStatus = false;
    _this.dataList = [];
    _this.searchData = _this.initForm();
    _this.activeKey = _this.$enum.warehouse.InventoryReservedOrderTypeEnum.OUTBOUND_ORDER;
    _this.total = 0;
    _this.inventoryReservedOrderTypeEnum = [];
    return _this;
  }

  OnwayDetail.prototype.onVisibleChange = function (value) {
    this.total = 0;
    this.dataList = [];

    if (value === true && this.data) {
      this.searchData = this.initForm();
      this.queryDataList();
    }
  };

  OnwayDetail.prototype.filterInventoryReservedOrderTypeEnum = function (list) {
    var _this = this;

    if (this.productQuanlity === this.$enum.product.ProductQualityEnum.BAD) {
      return this.inventoryReservedOrderTypeEnum.filter(function (item) {
        return item.value === _this.$enum.warehouse.InventoryReservedOrderTypeEnum.OUTBOUND_ORDER;
      });
    }

    return this.inventoryReservedOrderTypeEnum;
  };

  OnwayDetail.prototype.queryDataList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res_1, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(this.activeKey === this.$enum.warehouse.InventoryReservedOrderTypeEnum.OUTBOUND_ORDER)) return [3, 2];
            return [4, this.$api.warehouse.queryBatchInventoryDetailList(this.searchData)];

          case 1:
            res_1 = _a.sent();

            if (res_1.code === 0) {
              this.dataList = res_1.data.list;
              this.total = res_1.data.total;
            }

            return [2];

          case 2:
            return [4, this.$api.warehouse.queryOrderReservedList({
              warehouse_code: this.data.warehouse_code,
              product_sku: this.data.product_sku,
              order_type: this.activeKey,
              product_quanlity: this.productQuanlity,
              page_index: this.searchData.page_index,
              page_size: this.searchData.page_size
            })];

          case 3:
            res = _a.sent();
            this.dataList = res.data.list.map(function (item) {
              return {
                add_time: item.create_time,
                business_code: item.order_code,
                operate_quantity: item.quantity
              };
            });
            this.total = res.data.total;
            return [2];
        }
      });
    });
  };

  OnwayDetail.prototype.created = function () {
    this.columns = [{
      title: this.t('单号'),
      dataIndex: 'business_code',
      width: '35%'
    }, {
      title: this.t('商品数量'),
      dataIndex: 'operate_quantity',
      align: 'right',
      width: '35%'
    }, {
      title: this.t('创建时间'),
      dataIndex: 'add_time'
    }];
  };

  OnwayDetail.prototype.initForm = function () {
    return {
      product_barcode: this.data.product_barcode,
      batch_id: this.data.id,
      product_quanlity: this.productQuanlity,
      page_index: 1,
      page_size: 20
    };
  };

  OnwayDetail.prototype.handleTabChange = function () {
    this.searchData.page_index = 1;
    this.queryDataList();
  };

  OnwayDetail.prototype.handlePageChange = function (pageIndex, pageSize) {
    this.searchData.page_index = pageIndex;
    this.searchData.page_size = pageSize;
    this.queryDataList();
  };

  __decorate([Prop({
    type: Object,
    "default": function _default() {}
  })], OnwayDetail.prototype, "data", void 0);

  __decorate([Prop({
    type: Number,
    "default": null
  })], OnwayDetail.prototype, "productQuanlity", void 0);

  __decorate([enumData('Inventory/InventoryReservedOrderTypeEnum')], OnwayDetail.prototype, "inventoryReservedOrderTypeEnum", void 0);

  __decorate([enumData('Outbound/ProductQualityEnum')], OnwayDetail.prototype, "orderProductQualityEnum", void 0);

  __decorate([Watch('visible')], OnwayDetail.prototype, "onVisibleChange", null);

  __decorate([loading('loadingStatus')], OnwayDetail.prototype, "queryDataList", null);

  OnwayDetail = __decorate([Component], OnwayDetail);
  return OnwayDetail;
}(Vue);

export default OnwayDetail;